import { render, staticRenderFns } from "./tabTwo.vue?vue&type=template&id=751d3f06&scoped=true&"
import script from "./tabTwo.vue?vue&type=script&lang=js&"
export * from "./tabTwo.vue?vue&type=script&lang=js&"
import style0 from "./tabTwo.vue?vue&type=style&index=0&id=751d3f06&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "751d3f06",
  null
  
)

export default component.exports